"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZNumberingConfig = void 0;
const zod_1 = require("zod");
const ZBlockNumbering = zod_1.z.enum(['manual', 'auto', 'none']);
exports.ZNumberingConfig = zod_1.z.object({
    slug: ZBlockNumbering,
    sceneHeading: ZBlockNumbering,
    bracket: ZBlockNumbering,
    dual_dialogue: ZBlockNumbering,
    dialogue: ZBlockNumbering,
});
